@if (online) {
  <div class="px-2 fw-bold text-bg-success rounded" title="{{ onlineBadgeTitle }}">
    <i class="bi-globe2"></i>
  </div>
} @else {
  <div class="px-2 fw-bold text-bg-danger rounded" title="{{ onlineBadgeTitle }}">
    <i class="bi-globe2"></i>
  </div>
}
